<template>
  <div>
    <PageTitle
      tag="h1"
      no-border
      class="my-2 mb-5 mb-md-4 mt-4 mt-md-5 text-center text-md-left"
    >
      {{ $t('aboutCompany') }}
    </PageTitle>
    <CompanyForm :company="company" class="pb-12" />
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle';
import CompanyForm from '../components/Company/Form.vue';

export default {
  name: 'Company',
  metaInfo() {
    return {
      title: this.$t('aboutCompany'),
    };
  },
  components: {
    PageTitle,
    CompanyForm,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .tab-name {
    font-size: 1.125rem;
  }
}

</style>

<i18n locale="en" lang="yaml">
  aboutCompany: Company
</i18n>

<i18n locale="ru" lang="yaml">
  aboutCompany: О компании
</i18n>
